import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { Box } from '@mui/system'
import Table from 'common/components/Table'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { useContext, useState } from 'react'
import InformesHelper from '../helpers/InformesHelper'
import { InformesContext } from '../providers/InformesProvider'
import { standardFilterFieldSx } from '../styles/filterFieldStyles'

/**
 *
 * @param {Object} props
 * @param {InformeFilter} props.filter
 * @param {boolean} props.validating
 * @param {(newValue: any, pos: string) => void} props.changeFilter
 * @param {FiltersValuePosition} props.position
 * @param {boolean} props.disabled
 */
const FilterListOfValues = ({ filter, validating, changeFilter, position, disabled }) => {
  const [loading, setLoading] = useState(false)
  const Context = useContext(InformesContext)
  const [text, setText] = useState('')
  const { handleModal } = useContext(CustomModalContext)

  const getLov = async () => {
    if (text) {
      setText('')
      changeFilter('', `${filter?.nombre_filtro}${position}`)
      return
    }
    setLoading(true)
    try {
      const response = await InformesHelper.getListOfValues(
        Context?.active?.current?.nombre_informe,
        filter?.lista_valores,
      )
      /** @type {CustomTableGridOptions[]} */
      const newStructure =
        response?.columnas?.map((item, index) => {
          return { key: item.etiqueta, value: `${item.tipo}${index + 1}`, flex: 1 }
        }) ?? []

      handleModal({
        type: ModalTypes.Custom,
        enabled: true,
        closable: true,
        content: (
          <Box
            sx={{
              px: 1,
              pt: 1,
              width: { xs: '100%', sm: '60vw' },
              minWidth: '60vw',
              backgroundColor: 'background.default',
              '& .MuiDataGrid-toolbarContainer > .MuiTextField-root': {
                width: '100%',
              },
              '& .MuiDataGrid-toolbarContainer > button': {
                display: 'none !important',
                backgroundColor: 'red !important',
              },
            }}
          >
            <Table
              showInternalSearch={true}
              dataSource={response?.registros ?? []}
              page={1}
              loading={false}
              rowsPerPage={12}
              variant="compact"
              onRowClick={({ row }) => {
                const tipo_columna =
                  response?.columnas[parseInt(response?.columna_retorno) - 1].tipo
                const newValue = row[`${tipo_columna}1`] ?? ''
                const text = `${newValue} | ${row[`${tipo_columna}2`]}`
                setText(text)
                changeFilter(newValue, `${filter?.nombre_filtro}${position}`)
                handleModal({ enabled: false })
              }}
              count={response?.registros?.length}
              fields={newStructure.map((item) => {
                /**@type {TableField}**/
                const newItem = { ...item }
                newItem.field = item.value
                newItem.title = item.key
                return newItem
              })}
            />
          </Box>
        ),
      })

      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  const error =
    filter.obligatorio === 'S' &&
    validating &&
    !Context.active.filterData[`${filter.nombre_filtro}${position}`]

  const label = `${filter.titulo_columna} ${position.length > 0 ? position.slice(1) : position}`

  return (
    <TextField
      fullWidth
      variant="standard"
      sx={standardFilterFieldSx}
      label={label}
      value={text}
      error={error}
      disabled={loading || disabled}
      required={filter.obligatorio === 'S'}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end" sx={{ mr: 0 }}>
            <IconButton
              aria-label="abrir lista de valores"
              onClick={getLov}
              disabled={loading || disabled}
              size="small"
              edge="end"
            >
              {loading ? (
                <CircularProgress size={20} />
              ) : text ? (
                <ClearIcon color={error ? 'error' : 'inherit'} />
              ) : (
                <SearchIcon color={error ? 'error' : 'inherit'} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default FilterListOfValues
